import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Download, ChevronLeft, ChevronRight } from 'lucide-react';
import './ImagePortal.css';

const ImagePortal = ({
                         image,
                         onClose,
                         onPrevious,
                         onNext,
                         totalImages,
                         currentIndex
                     }) => {
    const [isLoading, setIsLoading] = useState(true);

    const handleKeyDown = (e) => {
        e.stopPropagation();
        switch (e.key) {
            case 'ArrowLeft':
                if (onPrevious) onPrevious();
                break;
            case 'ArrowRight':
                if (onNext) onNext();
                break;
            case 'Escape':
                onClose();
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onPrevious, onNext]);

    const handleDownload = (e) => {
        e.stopPropagation();
        const filename = image.split('/').pop();
        const link = document.createElement('a');
        link.href = image;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return createPortal(
        <div className="portal-overlay" onClick={onClose}>
            <div className="portal-content" onClick={e => e.stopPropagation()}>
                <div className="portal-buttons">
                    <button
                        onClick={handleDownload}
                        className="portal-button"
                        aria-label="Download image"
                    >
                        <Download size={24}/>
                    </button>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }}
                        className="portal-button"
                        aria-label="Close"
                    >
                        <X size={24}/>
                    </button>
                    <div className="image-counter">
                        {currentIndex + 1} / {totalImages}
                    </div>
                </div>
                <div className="portal-image-container">
                    <button
                        className="portal-nav-button portal-nav-button-left"
                        onClick={(e) => {
                            e.stopPropagation();
                            onPrevious();
                        }}
                        aria-label="Previous image"
                    >
                        <ChevronLeft size={48} />
                    </button>

                    <div className="image-wrapper">
                        {isLoading && (
                            <div className="loading-indicator">Loading full-size image...</div>
                        )}
                        <img
                            src={image}
                            alt="Selected"
                            className="portal-image"
                            onLoad={() => setIsLoading(false)}
                            style={{ display: isLoading ? 'none' : 'block' }}
                        />
                    </div>

                    <button
                        className="portal-nav-button portal-nav-button-right"
                        onClick={(e) => {
                            e.stopPropagation();
                            onNext();
                        }}
                        aria-label="Next image"
                    >
                        <ChevronRight size={48} />
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ImagePortal;